import { Component } from '@theme/component';

/**
 * Randomizes the homepage chef collaborations and keeps the visible set small.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} [grid]
 *
 * @extends Component<Refs>
 */
class HomeChefCollabs extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.#prepareCards();
  }

  #prepareCards() {
    const { grid } = this.refs;

    if (!(grid instanceof HTMLElement) || grid.dataset.prepared === 'true') return;

    const cards = Array.from(grid.querySelectorAll('[data-home-chef-collab-card]'));
    const visibleCards = this.#shuffle(cards).slice(0, this.limit);

    grid.replaceChildren(...visibleCards);
    grid.dataset.prepared = 'true';
    this.setAttribute('initialized', '');
  }

  /**
   * @template T
   * @param {T[]} items
   * @returns {T[]}
   */
  #shuffle(items) {
    const shuffledItems = [...items];

    for (let index = shuffledItems.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [shuffledItems[index], shuffledItems[randomIndex]] = [shuffledItems[randomIndex], shuffledItems[index]];
    }

    return shuffledItems;
  }

  get limit() {
    const limit = Number(this.dataset.limit);

    return Number.isFinite(limit) && limit > 0 ? limit : 3;
  }
}

if (!customElements.get('home-chef-collabs')) {
  customElements.define('home-chef-collabs', HomeChefCollabs);
}
